"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _operationManifest = _interopRequireDefault(require("customer-data-sidebar/js/operation-manifest.json"));

try {
  (function () {
    var matches = window.location.pathname.match(/contacts\/\d+\/(contact|company|deal|ticket)?\/(\d+)/);

    if (!matches) {
      return;
    }

    var objectType = matches[1].toUpperCase();
    var subjectId = parseInt(matches[2], 10);

    function url(endpoint) {
      var env = window.location.origin.includes('hubspotqa') ? 'qa' : '';
      return "https://app.hubspot" + env + ".com/api-passthrough/" + endpoint;
    }

    var getVariables = function getVariables(operationName) {
      switch (operationName) {
        case 'Sidebar_Query':
          return {
            subjectId: subjectId,
            objectType: objectType,
            isPreview: false
          };

        default:
          return {
            subjectId: subjectId,
            objectType: objectType
          };
      }
    };

    var upfrontQueryListByType = {
      CONTACT: ['AboutCard_Query', 'Sidebar_Query'],
      COMPANY: ['AboutCard_Query', 'Sidebar_Query'],
      DEAL: ['AboutCard_Query', 'Sidebar_Query'],
      TICKET: ['AboutCard_Query', 'Sidebar_Query']
    };

    if (objectType && subjectId) {
      upfrontQueryListByType[objectType].forEach(function (operationName) {
        var query = _operationManifest.default[operationName].query;
        var variables = getVariables(operationName);
        var requestName = operationName + variables.objectType + variables.subjectId;
        window.quickFetch.makeEarlyRequest(requestName, {
          url: url('graphql/crm'),
          timeout: 15000,
          dataType: 'json',
          contentType: 'application/json',
          type: 'POST',
          data: JSON.stringify({
            operationName: operationName,
            query: query,
            variables: variables
          })
        });
      });
    }
  })();
} catch (e) {// Ignore
}